import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import CollectionHeader from './CollectionHeader'
import CollectionBody from './CollectionBody'
import { Spin } from 'antd'
import SearchProgressBar from '../search-result/SearchProgressBar'
import './collection.css'

const spinnerStyle = {
  textAlign: 'center',
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
  marginBottom: 20,
  padding: '30px 50px',
  margin: '20px 0'
}

export class Collection extends Component {
  render() {
    const { title, isFetching, keyCollection, password, userWhoShared, objectSharedType } = this.props

    return (
      <React.Fragment>
        <CollectionHeader
          title={title}
          userWhoShared={userWhoShared}
          keyCollection={keyCollection}
          password={password}
          objectSharedType={objectSharedType}
        />
        {isFetching && (
          <div style={spinnerStyle}>
            {/* Buscador: barra de progreso en vez del spinner (feedback QA/Ricardo) */}
            {keyCollection === 'searcher' ? (
              <SearchProgressBar />
            ) : (
              <Spin spinning={isFetching} />
            )}
          </div>
        )}
        {!isFetching && <CollectionBody keyCollection={keyCollection} password={password} />}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps
  switch (keyCollection) {
    case 'assetsRoot':
      return {
        isFetching: state.assetsRoot.isFetching
      }
    case 'assetsLastUploads':
      return {
        isFetching: state.assetsLastUploads.isFetching
      }
    case 'assetsShared':
      return {
        isFetching: state.assetsShared.isFetching
      }
    case 'assetsFavorites':
      return {
        isFetching: state.assetsFavorites.isFetching
      }
    case 'assetsExplore':
      return {
        isFetching: state.assetsExplore.isFetching
      }
    case 'searcher':
      return {
        isFetching: state.searcher.isFetching
      }
    case 'assetsPublicShared':
      return {
        isFetching: state.assetsPublicShared.isFetching
      }
    default:
      return {}
  }
}

export default injectIntl(withRouter(connect(mapStateToProps)(Collection)))
